import React, { useState } from 'react';
import LineIcon from '@mui/icons-material/TableRows';

import { MenuAnchor } from '@paragon/client-tools';
import { Line } from '@paragon/contract-library';
import { hasSupervisorFeatureFlag } from '@paragon/login-tools';

import { useLineBreadcrumbs } from '../../../selectors/breadcrumbsSelector';
import { useAppSelector } from '../../hooks';
import { Breadcrumbs } from '../Breadcrumbs';
import { LineMenu } from '../menus/LineMenu';
import { BaseCard } from './BaseCard';

export function LineCard(props: { line: Line }) {
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);
  const [menuAnchor, setMenuAnchor] = useState<MenuAnchor>(null);

  const breadcrumbs = useLineBreadcrumbs(props.line.guid);

  return (
    <BaseCard
      avatar={<LineIcon />}
      title={props.line.name}
      subheader={breadcrumbs.length >= 2 ? <Breadcrumbs omitSelf disableLinks crumbs={breadcrumbs} /> : undefined}
      linkTo={`/lines/${props.line.guid}`}
      menu={
        isSupervisor ? (
          <LineMenu line={props.line} anchor={menuAnchor} onClose={() => setMenuAnchor(null)} />
        ) : undefined
      }
      onSetMenuAnchor={setMenuAnchor}
    />
  );
}
